import { SvgIcon, SvgIconProps } from '@mui/material';

export function FilterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="leading icon">
          <path
            id="Vector"
            d="M14.25 1.50098H3.75C3.15326 1.50098 2.58097 1.73803 2.15901 2.15999C1.73705 2.58194 1.5 3.15424 1.5 3.75098V4.62848C1.49989 4.93818 1.56372 5.24458 1.6875 5.52848V5.57348C1.79346 5.8142 1.94354 6.03297 2.13 6.21848L6.75 10.8085V15.751C6.74974 15.8784 6.78198 16.0039 6.84365 16.1154C6.90533 16.2269 6.99442 16.3209 7.1025 16.3885C7.22186 16.4624 7.35958 16.5014 7.5 16.501C7.61741 16.5003 7.73301 16.472 7.8375 16.4185L10.8375 14.9185C10.9612 14.8562 11.0652 14.7608 11.138 14.643C11.2108 14.5252 11.2496 14.3895 11.25 14.251V10.8085L15.84 6.21848C16.0265 6.03297 16.1765 5.8142 16.2825 5.57348V5.52848C16.4166 5.2468 16.4907 4.94031 16.5 4.62848V3.75098C16.5 3.15424 16.2629 2.58194 15.841 2.15999C15.419 1.73803 14.8467 1.50098 14.25 1.50098ZM9.9675 9.96848C9.89799 10.0386 9.843 10.1217 9.80567 10.213C9.76835 10.3044 9.74943 10.4023 9.75 10.501V13.786L8.25 14.536V10.501C8.25057 10.4023 8.23165 10.3044 8.19433 10.213C8.157 10.1217 8.10201 10.0386 8.0325 9.96848L4.0575 6.00098H13.9425L9.9675 9.96848ZM15 4.50098H3V3.75098C3 3.55206 3.07902 3.3613 3.21967 3.22065C3.36032 3.07999 3.55109 3.00098 3.75 3.00098H14.25C14.4489 3.00098 14.6397 3.07999 14.7803 3.22065C14.921 3.3613 15 3.55206 15 3.75098V4.50098Z"
            fill="currentcolor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
